import React from 'react';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Llevo 15 años dando clases de matemática en primaria y nunca había encontrado algo tan completo. Antes me pasaba los domingos enteros armando actividades, buscando ejercicios en internet y tratando de organizar la semana. Desde que tengo el Mega Kit, llego al aula con todo listo. Me ahorró horas de planificación y ahora tengo todo organizado de verdad.',
    author: 'Claudia M.',
    details: '42 años, Córdoba'
  }, {
    text: 'Soy profe de secundaria y la verdad es que antes improvisaba casi todas las clases. No porque no supiera el tema, sino porque no me daba el tiempo para preparar todo como quería. Con este sistema cambió todo: tengo las clases armadas, los ejercicios listos y hasta las evaluaciones. Ahora mis alumnos notan la diferencia y yo llego mucho más tranquilo.',
    author: 'Martín R.',
    details: '35 años, Buenos Aires'
  }, {
    text: 'Lo que más me sorprendió fue la claridad del material. Yo siempre tuve problemas para explicar fracciones y geometría de una forma que los chicos realmente entiendan. Con los recursos visuales y las actividades progresivas del kit, los alumnos entienden más rápido y participan mucho más en clase. Es un antes y un después.',
    author: 'Lucía P.',
    details: '28 años, Mendoza'
  }, {
    text: 'Trabajo en dos escuelas, mañana y tarde, y siempre sentía que estaba corriendo de un lado a otro sin poder organizarme bien. Este kit me dio la estructura que necesitaba. Ahora tengo el año planificado, sé qué voy a dar cada semana y tengo material de refuerzo para los alumnos que van más lento. Es justo lo que necesitaba para dejar de estar corriendo todo el tiempo.',
    author: 'Andrea S.',
    details: '48 años, Rosario'
  }, {
    text: 'Al principio dudé porque pensé que iba a ser otro PDF genérico que termina juntando polvo en la computadora. Pero cuando lo abrí me di cuenta de que es un sistema real, con todo pensado para usar directamente. Por fin puedo organizar mis clases sin estrés, y lo mejor es que el material es adaptable. Lo recomiendo a todos mis colegas docentes.',
    author: 'Fernando G.',
    details: '31 años, Tucumán'
  }];
  return <section className="py-12 px-6 bg-[#13132b]" data-id="element-241">
      <div className="text-center mb-10" data-id="element-242">
        <h2 className="text-2xl font-black text-white mb-2" data-id="element-243">
          LO QUE DICEN LOS DOCENTES
        </h2>
        <div className="flex justify-center gap-1 text-yellow-400" data-id="element-244">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-245" />)}
        </div>
      </div>

      <div className="space-y-5" data-id="element-246">
        {testimonials.map((testimonial, index) => <div key={index} className="bg-white/5 border border-white/10 rounded-xl p-6 relative" data-id="element-247">
            <Quote className="absolute top-4 right-4 w-8 h-8 text-white/5" data-id="element-248" />

            <div className="flex gap-1 text-yellow-400 mb-4" data-id="element-249">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-current" data-id="element-250" />)}
            </div>

            <p className="text-gray-200 text-sm font-medium leading-7 mb-5 italic" data-id="element-251">
              "{testimonial.text}"
            </p>

            <div className="flex items-center gap-3 pt-3 border-t border-white/5" data-id="element-252">
              <div className="w-11 h-11 rounded-full bg-gradient-to-br from-slate-700 to-slate-800 flex items-center justify-center border border-white/10" data-id="element-253">
                <span className="text-sm font-bold text-gray-300" data-id="element-254">
                  {testimonial.author.charAt(0)}
                </span>
              </div>
              <div data-id="element-255">
                <p className="text-white text-sm font-bold" data-id="element-256">
                  {testimonial.author}
                </p>
                <p className="text-gray-500 text-xs" data-id="element-257">{testimonial.details}</p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}